import { DOCUMENT } from '@angular/common';
import { ErrorHandler, inject, Injectable, NgZone } from '@angular/core';
import { ApolloError } from '@apollo/client/core';
import { ErrorService } from '@shared/services';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly _error = inject(ErrorService);
  private readonly _zone = inject(NgZone);
  private readonly _document = inject(DOCUMENT);

  handleError(error: Error): void {
    // ApolloErrors are already surfaced via the Apollo `onError` link (see graphql-api.config.ts)
    // - reporting them here too would show the user a duplicate error notification.
    if (!(error instanceof ApolloError)) {
      this._zone.run(() => {
        console.error(error);
        this._error.notify(error.message ?? 'Unbekannter Fehler', {
          location: this._document.location.href,
        });
      });
    }
  }
}
